import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import Profile from "../../components/profile";
import Banner from "../../images/lehrpraxis/bg_stetoskop_herz-removebg-preview.png";

const Lehrpraxis = () => {
    const teamdata = [
        {
            "title": "Prim.Dr. Lukas Stifter",
            "descr": "Facharzt für Pathologie, Institutsvorstand der Pathologie Klinik Hietzing"
        },
        {
            "title": "Dr. Christina Gruber",
            "descr": "Facharzt für Anästhesie"
        },
        {
            "title": "Dr. Sonja Mahrer",
            "descr": "Fachärztin für Innere Medizin, Oberärztin und Leitung der Internistischen Notaufnahme der Klinik Favoriten"
        },
        {
            "title": "Dr. Merima Herac",
            "descr": ""
        },
        {
            "title": "Dr. Maja Cerkez",
            "descr": "Fachärztin für Neurologie"
        },
        {
            "title": "Dr. Dominik Draxler",
            "descr": ""
        },
        {
            "title": "Dr. Katharina Eichbichler",
            "descr": ""
        },
        {
            "title": "Dr. Chao Zhang",
            "descr": "Facharzt für Innere Medizin und Kardiologie"
        },
        {
            "title": "Dr. Martin Langeder",
            "descr": ""
        },
        {
            "title": "Dr. Martin Leitner",
            "descr": ""
        },
        {
            "title": "Dr. Andrea Goldschmied",
            "descr": ""
        },
    ]
    const images = require.context('../../images/lehrpraxis/profiles', false, /\.jpg$/);
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />
                <div className="page-container">
                    <h1> Team - Absolventen Facharzt Lehrpraxis </h1>
                    {teamdata.map((person, key_id) => (<Profile  images={images} key_id={key_id} object={person}/>))}
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Lehrpraxis;
